import React from 'react';
import { Button, Form, } from 'react-bootstrap';
import { ClipboardButton, Toast, } from '@payit/cool-web-ui-library';
import './BulkRefundJSONGeneratorView.css';
import HtmlUtils from '../../../../modules/HtmlUtils';
import PaymentGatewayService from '../../../../service/PaymentGatewayService';

class BulkRefundJSONGeneratorView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rawUserInput: '',
      selectedUserRefundReason: 'Please select a reason from the dropdown',
      inputFormat: 'comma',
      jsonBody: { lines: [], },
      refundNote: '',
      refundReasons: [],
    };
  }

  async componentDidMount() {
    await this.getRefundReasons();
  }

  reset = async () => {
    await this.getRefundReasons();

    this.setState(prevState => ({
      rawUserInput: '',
      selectedUserRefundReason: prevState.refundReasons.length > 0 ? prevState.refundReasons[0].value : 'Please select a reason from the dropdown',
      inputFormat: 'comma',
      jsonBody: { lines: [], },
      refundNote: '',
    }));
  };

  async getRefundReasons() {
    await PaymentGatewayService.refund.getRefundReasons()
      .then(response => {
        const { refundReasons, } = response.data;
        const tempRefundReasons = [];
        Object.entries(refundReasons).map(([ key, val, ]) => (
          tempRefundReasons.push({ value: key, display: `${val.name}: ${val.description}`, })
        ));
        this.setState({
          refundReasons: tempRefundReasons,
          selectedUserRefundReason: tempRefundReasons[0].value,
        });
      });
  }

  onUserTransactionInputChange = (event) => {
    this.setState({
      rawUserInput: event.target.value,
    });
  };

  onDropDownChange = (event) => {
    this.setState({
      selectedUserRefundReason: event.target.value,
    });
  };

  onInputFormatChange = (event) => {
    this.setState({
      inputFormat: event.target.value,
    });
  };

  onUserRefundNoteInputChange = (event) => {
    this.setState({
      refundNote: event.target.value,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault(); // prevents browser from reload on form submission

    const {
      rawUserInput, inputFormat, selectedUserRefundReason, refundNote,
    } = this.state;

    const transactionIds = inputFormat === 'comma' ? rawUserInput.split(',') : rawUserInput.split('\n');
    const mappedTransactionIds = transactionIds.map((input) => input.trim());

    this.generateJsonBody(mappedTransactionIds, selectedUserRefundReason, refundNote);
  };

  generateJsonBody(transactionIds, refundReason, refundNote) {
    const jsonBody = {
      lines: [],
    };

    transactionIds.forEach((id) => {
      jsonBody.lines.push({
        transactionId: id,
        idempotencyId: id,
        lineItems: null,
        reason: refundReason,
        note: refundNote,
      });
    });

    this.setState({ jsonBody, });
  }

  render() {
    const {
      rawUserInput, jsonBody, refundNote, refundReasons,
    } = this.state;

    return (
      <div className="everything">
        <div className="primaryBody">
          <Form onSubmit={this.handleSubmit}>
            <Form.Label style={{ color: '#333', }}>Bulk Transaction Input</Form.Label>
            <p style={{ color: '#6c757d', }}>
              This page was built in order to quickly generate a JSON body for a Bulk Refund Request.
              You will need to complete & send the request via Postman.
            </p>

            <Form.Group className="mb-3">
              <Form.Label>Input Format</Form.Label>
              <div key='inline-radio' className="mb-3">
                <Form.Check
                  inline
                  label="Comma separated"
                  name="inputFormat"
                  type="radio"
                  id='inline-radio-1'
                  value="comma"
                  checked={this.state.inputFormat === 'comma'}
                  onChange={this.onInputFormatChange}
                />
                <Form.Check
                  inline
                  label="Newline separated"
                  name="inputFormat"
                  type="radio"
                  id='inline-radio-2'
                  value="newline"
                  checked={this.state.inputFormat === 'newline'}
                  onChange={this.onInputFormatChange}
                />
              </div>
            </Form.Group>

            <p style={{ color: '#6c757d', }}>Enter transaction IDs in the follow text area in the format you have chosen above.</p>
            <Form.Control
              as="textarea"
              value={rawUserInput}
              onChange={this.onUserTransactionInputChange}
              placeholder="UUIDs here"
              rows={4}
              style={{ marginBottom: '20px', }}
            />

            <Form.Group className="mb-3" controlId="refundReasonSelect">
              <Form.Label>Refund Reason</Form.Label>
              <Form.Select onChange={this.onDropDownChange}>
                {refundReasons.map((reason) => (
                  <option key={reason.value} value={reason.value}>{reason.display}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Label>Detailed refund reason</Form.Label>
            <Form.Control
              as="textarea"
              value={refundNote}
              onChange={this.onUserRefundNoteInputChange}
              placeholder="Enter the context around the refund reason"
              rows={1}
              style={{ marginBottom: '20px', }}
            />

            <Button variant="primary" type="submit">Generate this Juston™️</Button>
            <Button variant="danger" onClick={this.reset} style={{ float: 'right', }}>Reset</Button>
          </Form>
        </div>

        <div className="copyJsonToClipboard">
          <span>Copy JSON to clipboard: </span>
          <ClipboardButton stringToCopy={HtmlUtils.toHtmlText(JSON.stringify(jsonBody, null, 2))} />
          <br />
          <Toast />
        </div>

        <pre className="jsonOutput">
          {JSON.stringify(jsonBody, null, 2)}
        </pre>

        <br />
        <br />
        <br />
        <br />
        <br />

      </div>
    );
  }
}

export default BulkRefundJSONGeneratorView;
